import dayjs from 'dayjs'
import { ExistingMessage, Message } from 'ComponentLibrary/src/molecules/Message/types'

export const getIsMessageAggregated = ({ messages, index }: { messages: Message[]; index: number }) => {
    if (index === 0) {
        return false
    }
    const previousMessage = messages[index - 1]
    const currentMessage = messages[index]
    // We don't aggregate deleted messages
    if (previousMessage.message_type === 'deleted_message' || currentMessage.message_type === 'deleted_message') {
        return false
    }
    const previousMessageCreatedOn = dayjs(previousMessage.created_on)
    const currentMessageCreatedOn = dayjs(currentMessage.created_on)

    if (previousMessage.message_type === 'system_message' || currentMessage.message_type === 'system_message') {
        return false
    }
    if (!haveSameExistingMessageAuthor(previousMessage, currentMessage)) {
        return false
    }
    if (!previousMessageCreatedOn.isSame(currentMessageCreatedOn, 'day')) {
        return false
    }
    return Math.abs(previousMessageCreatedOn.diff(currentMessageCreatedOn, 'minutes')) <= 30
}

function haveSameExistingMessageAuthor(firstMessage: ExistingMessage, secondMessage: ExistingMessage): boolean {
    if (firstMessage.author_type !== secondMessage.author_type) {
        return false
    }

    if (firstMessage.author_type === 'external_participant') {
        return firstMessage.external_participant_id === secondMessage.external_participant_id
    }

    return firstMessage.user_id === secondMessage.user_id
}
